export default "void main() {\r\n    gl_FragColor = vGPUColor;\r\n}\r\n";